import * as THREE from 'three';
import vertexShader from './particles.vs.glsl';
import fragmentShader from './particles.fs.glsl';

export default class Particles {

    constructor(scene, texture){

        this.scene = scene;
        this.count = 40;

        this.guiParams = {
            size: 6,
            progressSpeed:0.000003,
            //perlinFrequency:0.05,
            perlinFrequency:(Math.random() - 0.5) * 0.05,//이게 맞나..잘모르겠음
            perlinMultiplier:1,
        }

        this.setGeometry()
        this.setMaterial(texture)
        this.setPoints()
    }


    setGeometry() {

        if(this.geometry) {
            this.geometry.dispose();
        }

        this.geometry = new THREE.BufferGeometry();

        const positionArray = new Float32Array(this.count * 3);
        const progressArray = new Float32Array(this.count);
        const sizeArray = new Float32Array(this.count);
        const alphaArray = new Float32Array(this.count);

        const vector = new THREE.Vector3();

        for(let i = 0; i < this.count; i++) {

            const i3 = i * 3;

            vector.x = (Math.random() - 0.5) * 3;
            vector.y = (Math.random() - 0.5) * 2;
            vector.z = (Math.random() - 0.5) * 10;
            vector.setLength(1);
            vector.multiplyScalar(this.lerp(0, 20, Math.random()));
            
            positionArray[i3] = vector.x;
            positionArray[i3+1] = vector.y;
            positionArray[i3+2] = vector.z;

            //
            progressArray[i] = Math.random();
            sizeArray[i] = Math.random() * 10;
            alphaArray[i] = Math.random()
        }

        this.geometry.setAttribute('position', new THREE.Float32BufferAttribute(positionArray, 3));
        this.geometry.setAttribute('aProgress', new THREE.Float32BufferAttribute(progressArray, 1));
        this.geometry.setAttribute('aSize', new THREE.Float32BufferAttribute(sizeArray, 1));
        this.geometry.setAttribute('aAlpha', new THREE.Float32BufferAttribute(alphaArray, 1));
    }

    lerp = (a, b, r) => {
        return a + ((b -a) * r);
    }


    setMaterial(maskTexture) {

        this.material = new THREE.ShaderMaterial({
            transparent: true,
            blending: THREE.AdditiveBlending,
            depthTest: false,
            uniforms: {
                uTime: {value: 0},
                uSize: {value: this.guiParams.size},
                uProgressSpeed: {value: this.guiParams.progressSpeed},
                uPerlinFrequency: {value: this.guiParams.perlinFrequency},
                uPerlinMultiplier: {value: this.guiParams.perlinMultiplier},
                uMask: {value: maskTexture},
            },
            vertexShader: vertexShader,
            fragmentShader: fragmentShader
        });
    }


    initDebugGUI = (gui) => {

        const folder = gui.addFolder('Particles');

        folder.add(this.material.uniforms.uSize, 'value').min(0).max(200).step(0.1).name('Size');
        folder.add(this.material.uniforms.uProgressSpeed, 'value').min(0).max(0.0001).step(0.000001).name('ProgressSpeed');
        folder.add(this.material.uniforms.uPerlinFrequency, 'value').min(0).max(0.5).step(0.01).name('PerlinFrequency');
        folder.add(this.material.uniforms.uPerlinMultiplier, 'value').min(0).max(3).step(0.1).name('PerlinMultiplier');
    }

    setPoints() {
        this.points = new THREE.Points(this.geometry, this.material);
        this.points.position.y = - 5;
        this.scene.add(this.points);
    }

    update(elapsed) {
        this.material.uniforms.uTime.value = elapsed * 10000;
    }
}